/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Menu Actions
 */
// Constants
import {
  GET_ALL_MENUS,
  GET_MENU_BY_ROLE,
  GET_MENU_BY_USER,
  GET_ALL_PERMISSIONS,
  GET_MAIN_MENU_BY_ROLE
} from './constants';

/**
 * Call process to get all menus list
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_MENUS
 */
export const getMenusArray = (callback) => ({
  type: GET_ALL_MENUS,
  callback
});

/**
 * Call process to get menu by role
 * @param  { object } data - Menu Role
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_MENU_BY_ROLE
 */
export const getMenuByRole = (data, callback) => ({
  type: GET_MENU_BY_ROLE,
  payload: { data },
  callback
});

/**
 * Call process to get main menu by role
 * @param  { object } data - Menu Role
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_MENU_BY_ROLE
 */
export const getMainMenuByRole = (data, callback) => ({
  type: GET_MAIN_MENU_BY_ROLE,
  payload: { data },
  callback
});

/**
 * Call process to get menu by user
 * @param  { object } data - Menu User
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_MENU_BY_USER
 */
export const getMenuByUser = (data, callback) => ({
  type: GET_MENU_BY_USER,
  payload: { data },
  callback
});

/**
 * Call process to get all user permissions
 * @param  { object } data - Pagination data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PERMISSIONS
 */
export const getAllPermissions = (data, callback) => ({
  type: GET_ALL_PERMISSIONS,
  payload: { data },
  callback
});
